import { useState } from 'react';
import { useTranslation } from '../../i18n';
import { SUPPORTED_LANGS, changeLanguage, SupportedLang } from '../../i18n';

export function LanguageSettings() {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState<SupportedLang>(() => {
    const extractedLang = i18n.language.split('-')[0];
    return SUPPORTED_LANGS.includes(extractedLang as SupportedLang) 
      ? (extractedLang as SupportedLang) 
      : 'en';
  });

  const handleLangChange = (lang: SupportedLang) => {
    if (lang === currentLang) return;
    changeLanguage(lang);
    setCurrentLang(lang);
  };

  return (
    <div className="w-full">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-theme-text mb-2">
          {t('profile.settings.language.title')}
        </h3>
        <p className="text-theme-hint text-sm mb-4">
          {t('profile.settings.language.description')}
        </p>
        <div className="space-y-3">
          {SUPPORTED_LANGS.map((lang) => (
            <div
              key={lang}
              className={`relative p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                currentLang === lang
                  ? 'bg-blue-50 dark:bg-blue-950/20 border-2 border-blue-500'
                  : 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
              }`}
              onClick={() => handleLangChange(lang)}
            >
              <div className="flex items-center justify-between">
                <span
                  className={
                    currentLang === lang
                      ? 'font-medium text-blue-700 dark:text-blue-300'
                      : 'font-medium text-gray-900 dark:text-gray-100'
                  }
                >
                  {lang.toUpperCase()}
                </span>
                {currentLang === lang && (
                  <span className="material-symbols-outlined text-blue-600 dark:text-blue-400">
                    check_circle
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

